export default __webpack_public_path__ + "static/media/conferred-order.c26877b2.svg";